// extracted by mini-css-extract-plugin
module.exports = {"v-dialog--active":"TopLeftSectionPopup_v-dialog--active_ljmUX"};